import gql from 'graphql-tag';

const DaData = {
  addDadata: gql`
    query addDadata($input: DadataInput!) {
      addDadata(data: $input) {
        result
        error
        dadataItem {
          id
          fias_id
          country
          is_fixed
        }
      }
    }
  `
};

export default DaData;
